const VideoStatus = ({ currentFrame, totalFrames, currentTime, totalTime }) => {
  return (
      <div className="flex justify-between px-4 py-2 bg-gray-700 text-gray-300">
        <div>
          Frame: {currentFrame} / {totalFrames} ({Math.floor(currentFrame / totalFrames * 100)}%)
        </div>
        <div>
          Time: {currentTime} / {totalTime}
        </div>
      </div>
  );
};

export default VideoStatus;